import type { MapCanvasValue } from "../components/map/contexts/MapCanvasContext/MapCanvasContext.types";
import { compileImportFurniture } from "./compileImportFurniture";
import {
  configureImportedMeetingRooms,
  type ImportedMeetingRoomOptions
} from "./configureImportedMeetingRooms";

/** Final map used by preview, export, save and visual verification. Always start
 * from immutable recognition, so desk scaling and room placement apply once. */
export function finalizeImportedMap(
  source: MapCanvasValue,
  deskIds: ReadonlySet<string> = new Set(),
  rooms: ImportedMeetingRoomOptions = {
    markerOnTable: true,
    highlightRoom: false
  }
) {
  return configureImportedMeetingRooms(
    source,
    compileImportFurniture(source, deskIds),
    rooms
  );
}
